export default __webpack_public_path__ + "static/media/commentuser.2e7feaae.ae84f63c.jpg";